import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

const TERMS_SLOT = '__TERMS__';

export const StripeTermsAgreement: React.FC = () => {
  const { tq } = useTranslation('cashFundsShared');
  const [before, after = ''] = tq`By saving, you agree to Stripe's ${TERMS_SLOT}.`.split(TERMS_SLOT);

  return (
    <>
      {before}
      <TextV2
        as="a"
        href="https://stripe.com/legal/connect-account"
        target="_blank"
        rel="noopener noreferrer"
        display="inline"
        color="mono8"
        typographyVariant="label2"
        textDecoration="underline"
      >
        {tq`terms of service`}
      </TextV2>
      {after}
    </>
  );
};
